export enum SortDirection {
  up = 'up',
  down = 'down',
  none = 'none',
}

export enum ESortOrderMap {
  none,
  desc,
  asc,
}
